<template>
    <div class="gas-wrap">
        <el-tabs v-model="activeName">
            <el-tab-pane label="表格数据" name="table">
                <gastable v-if="activeName=='table'"></gastable>
            </el-tab-pane>

            <el-tab-pane label="曲线数据" name="curve">
                <gascurve v-if="activeName=='curve'"></gascurve>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
export default {
    name:"gas",
    data(){
        return {
            activeName:"table",
        }
    },
    components:{
        gastable:()=>import("./GasTable.vue"), // 表格数据
        gascurve:()=>import("./GasCurve.vue"), // 表格数据
    }
}
</script>

<style scoped>
.gas-wrap{
    padding: 10px;
}
</style>